import { api } from '@/api'

export interface ServiceCategory {
  id: string
  name: string
  slug: string
  description?: string
  parentId?: string | null
  isActive: boolean
  sortOrder: number
  createdAt: string
  updatedAt: string
}

export const getServiceCategoriesAction = () => api.v2.get<{ data: ServiceCategory[] }>('/service-category')

export const getServiceCategoryAction = (id: string) => api.v2.get<{ data: ServiceCategory }>(`/service-category/${id}`)

export const createServiceCategoryAction = (payload: Record<string, unknown>) =>
  api.v2.post<{ data: ServiceCategory }>('/service-category', payload)

export const updateServiceCategoryAction = (id: string, payload: Record<string, unknown>) =>
  api.v2.put<{ data: ServiceCategory }>(`/service-category/${id}`, payload)

export const toggleServiceCategoryActivationAction = (id: string, is_active: boolean) =>
  api.v2.patch<{ data: ServiceCategory }>(`/service-category/${id}/toggle-activation`, { is_active })

export const deleteServiceCategoryAction = (id: string) => api.v2.delete(`/service-category/${id}`)
